
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import HeadTittle from '../../../../../components/HeadTittle';
import IdentityVerification from '../../../Visitor/Visitor/SubComponents/IdentityVerification';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { DownloadIcon } from '../../../../../components/buttons/IconButtons';
import {CommonIdentityVerificationApp} from "../../../Visitor/Request/Functionality/CommonIdentityVerificationApp";
/**
 *
 * @Author: Susana García Rodriguez
 * @JobTitle : Frontend Developer - IBL
 * @Email : sgarcia@ibl.mx
 *
 */
// Component responsible for displaying and managing user identity documents
const IdentityDocumentsGrid = ({ userTypeId }) => {
    const { id: userId } = useParams();
    const {
        item,
        identityDocuments,
        identityValidationType,
        identityValidationStatus,
        handleDownload,
        hasIdentityFiles
    } = CommonIdentityVerificationApp({
        userId,
        userTypeId
    });

    const { state } = useLocation();
    const backRoute = state?.backUrl;
    const currentTab = state?.currentTab;
    const navigate = useNavigate();

    // Navigates back to the previous screen while preserving the current tab
    const handleOnBack = () => {
        navigate(backRoute, { state: { currentTab } });
    };

    return (
        <>
            <HeadTittle name={'validation_identity'} onBack={handleOnBack}>
                { hasIdentityFiles &&
                    <ButtonAction
                        id='btn_idg_download'
                        name='download'
                        className='btn-icon-export'
                        Icon={DownloadIcon}
                        splitName={false}
                        onClick={handleDownload}
                    />
                }
            </HeadTittle>
            {identityDocuments && (
                <div className={'ml-15 mr-15'}>
                    <IdentityVerification
                        item={item}
                        disabled={true}
                        identityDocuments={identityDocuments}
                        identityValidationType={identityValidationType}
                        identityValidationStatus={identityValidationStatus}
                        userTypeId={userTypeId}
                    />
                </div>
            )}
        </>
    );
};

export default IdentityDocumentsGrid;
